import { useQuery } from "@tanstack/react-query";
import { syncReviews } from "../../../apis/venueDetails";

export function useSyncReviews({
  venueId,
  sortBy,
}: {
  venueId: string;
  sortBy: string;
}) {
  const { data, error, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["syncReviews", venueId, sortBy],
    queryFn: async () => {
      const data = await syncReviews({ venueId, sortBy });
      return data;
    },
    enabled: false,
  });
  return {
    data,
    error,
    isLoading: isLoading || isFetching,
    loadReviews: refetch,
  };
}
